import { requiredAvoidAction, type EncounterKind } from "../data/encounterPatterns";
import { FOODS, type FoodId, isFoodId } from "../data/foods";

export const CROUCH_FOOD_MULTIPLIER = 1.2;
export const HAZARD_CLEAR_POINTS = 15;

export function pointsForFood(id: FoodId, crouched = false): number {
  const base = FOODS[id].points;
  return crouched ? Math.round(base * CROUCH_FOOD_MULTIPLIER) : base;
}

export function addScore(current: number, foodId: string, crouched = false): number {
  if (!isFoodId(foodId)) {
    throw new Error(`Unknown food type: ${foodId}`);
  }
  return current + pointsForFood(foodId, crouched);
}

export function isHazardClearKind(kind: EncounterKind): boolean {
  const action = requiredAvoidAction(kind);
  return action === "jump" || action === "duck";
}

export function addHazardClearScore(current: number): number {
  return current + HAZARD_CLEAR_POINTS;
}
